import { render, staticRenderFns } from "./documentEdit.vue?vue&type=template&id=0b17172c&scoped=true&"
import script from "./documentEdit.vue?vue&type=script&lang=js&"
export * from "./documentEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b17172c",
  null
  
)

export default component.exports